module.exports = __webpack_public_path__ + "img/super-simon-sunhero.c3f241fc.png";